import Button from 'molecules/Button';
import Link from 'molecules/Link';
import RichText from 'molecules/RichText';

import type { NoIconCardConfigProps } from 'organisms/Cards/NoIconCard/config';
import type { FC } from 'react';

const NoIconCard: FC<NoIconCardConfigProps> = ({ title, description, button }) => (
  <Link
    href={button?.href}
    aria-label={title || button?.label}
    className="flex size-full rounded-lg border border-gray-300/50 bg-iconCardGradient p-5 backdrop-blur focus-outline-primary"
    enablePreview={false}
  >
    <div className="flex size-full flex-col gap-6">
      {(title || description) && (
        <div className="flex flex-col gap-3">
          {title && <h3 className="text-display-sm font-bold text-white">{title}</h3>}
          {description && <RichText text={description} className="text-md text-gray-300" />}
        </div>
      )}
      {button && (
        <Button
          label={button.label}
          semanticFallback="div"
          hierarchy="linkGray"
          endIcon="arrow-right"
          className="mt-auto"
        />
      )}
    </div>
  </Link>
);

export default NoIconCard;
